<template>
    <v-container app :fluid="true">
        <v-row justify="center">
            <v-col cols="10" class="pt-0 pb-1">
                <v-btn
                    dark
                    color="success"
                    class="float-right"
                    @click="handleSaveProduct"
                >
                    Guardar
                </v-btn>
                <v-btn
                    dark
                    color="error"
                    class="float-right mr-2"
                    @click="handleCancelSave"
                >
                    Cancelar
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="10" class="pt-0">
                <v-container class="pt-0 pl-0 pr-0">                    
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-card-title class="pt-1 pb-1">
                                    <span class="subtitle-2">Datos generales</span>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-text-field 
                                                    ref="name"
                                                    v-model="form.name" 
                                                    label="Nombre" 
                                                    outlined
                                                    dense
                                                    :rules="[() => !!form.name || 'Es necesario ingresar el nombre']"
                                                    hide-details="auto"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-autocomplete
                                                    ref="unit_id"
                                                    v-model="form.unit_id"
                                                    :items="units"
                                                    label="Unidad de medida"
                                                    outlined
                                                    dense
                                                    :item-text="customText"
                                                    item-value="id"
                                                    clearable
                                                    :rules="[() => !!form.unit_id || 'Es necesario ingresar seleccionar unidad de medida']"
                                                    hide-details="auto"
                                                    required
                                                ></v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-autocomplete
                                                    ref="brand_id"
                                                    v-model="form.brand_id"
                                                    :items="brands"
                                                    label="Marca"
                                                    outlined
                                                    dense
                                                    :item-text="customText"
                                                    item-value="id"
                                                    clearable
                                                    @change="handleChangeBrand"
                                                    :rules="[() => !!form.brand_id || 'Es necesario ingresar seleccionar una marca']"
                                                    hide-details="auto"
                                                    required
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-autocomplete
                                                    ref="pattern_id"
                                                    v-model="form.pattern_id"
                                                    :items="patterns"
                                                    label="Modelo"
                                                    outlined
                                                    dense
                                                    :item-text="customText"
                                                    item-value="id"
                                                    clearable
                                                    :rules="[() => !!form.pattern_id || 'Es necesario ingresar seleccionar modelo']"
                                                    hide-details="auto"
                                                    required
                                                ></v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="6">
                                                <v-autocomplete
                                                    ref="color_id"
                                                    v-model="form.color_id"
                                                    :items="colors"
                                                    label="Color"
                                                    outlined
                                                    dense
                                                    :item-text="customText"
                                                    item-value="id"
                                                    clearable
                                                    :rules="[() => !!form.color_id || 'Es necesario ingresar seleccionar color']"
                                                    hide-details="auto"
                                                    required
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="6">
                                                <v-text-field
                                                    ref="sku"
                                                    v-model="form.sku" 
                                                    label="SKU" 
                                                    outlined
                                                    dense
                                                    :rules="[() => !!form.sku || 'Es necesario ingresar sku']"
                                                    hide-details="auto"
                                                    required
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="4">
                                                <v-switch v-model="form.with_variants"
                                                    hide-details 
                                                    class="mt-0"
                                                    dense
                                                    label="Producto con variantes"
                                                    :false-value="false"
                                                    :true-value="true"
                                                    @change="handleChangeWithVariants">
                                                </v-switch>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row v-if="form.with_variants">
                        <v-col cols="12">
                            <v-card>
                                <v-card-title>
                                    <span class="subtitle-2">Variantes</span>
                                    <v-spacer></v-spacer>
                                    <v-btn small 
                                        class="float-right"
                                        dark
                                        color="blue"
                                        @click="hanndleViewAddVariant">
                                        Agregar
                                    </v-btn>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-data-table
                                        class="wost-table"
                                        :headers="variants_header"
                                        :items="variants_rows"
                                        fixed-header
                                        disable-pagination
                                        hide-default-footer
                                        no-data-text=""
                                    >
                                        <template v-slot:item.barcode="{item}">
                                            <v-text-field
                                                :value="item.barcode"
                                                outlined
                                                dense
                                                hide-details
                                                @focus="handleFocusInput(item)"
                                                @input="handleInputBarcode"
                                            ></v-text-field>
                                        </template>
                                        <template v-slot:item.unit_price="{item}">
                                            <v-text-field
                                                :value="item.unit_price"
                                                outlined
                                                hide-details
                                                dense
                                                type="number"
                                                prefix="S/"
                                                @focus="handleFocusInput(item)"
                                                @input="handleInputUnitPrice"
                                            ></v-text-field>
                                        </template>
                                        <template v-slot:item.wholesale_price="{item}">
                                            <v-text-field
                                                :value="item.wholesale_price"
                                                outlined
                                                hide-details
                                                dense
                                                type="number"
                                                prefix="S/"
                                                @focus="handleFocusInput(item)"
                                                @input="handleInputWholesalePrice"
                                            ></v-text-field>
                                        </template>
                                        <template v-slot:item.preferential_price="{item}">
                                            <v-text-field
                                                :value="item.preferential_price"
                                                outlined
                                                hide-details
                                                dense
                                                type="number"
                                                prefix="S/"
                                                @focus="handleFocusInput(item)"
                                                @input="handleInputPreferentialPrice"
                                            ></v-text-field>
                                        </template>

                                    </v-data-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
                
            </v-col>
            
        </v-row>

        <add-variant ref="addVariant"></add-variant>
    </v-container>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';

import router from '@/router/index';

import AddVariant from '../../components/Product/AddVariant';
import Tools from '../../helpers/Tools';

export default {
    name: 'CreateProduct',
    components: {
        AddVariant
    },
    data () {
        return {
            form:{
                name: null,
                category_id: null,
                brand_id: null,
                pattern_id: null,
                color_id: null,
                unit_id: null,
                sku: null,
                barcode: null,
                with_variants: false,
                variants: null,
                variants_header: null
            }
        }
    },
    computed: {
        ...mapState('categories', [
            'categories'
        ]),
        ...mapState('units', [
            'units'
        ]),
        ...mapState('brands', [
            'brands'
        ]),
        ...mapState('patterns', [
            'patterns'
        ]),
        ...mapState('colors', [
            'colors'
        ]),
        ...mapState('variants', [
            'variants_header',
            'variants_rows',
            'row_selected'
        ]),
        ...mapState('products', [
            'product_response'
        ])
    },
    methods: {        
        ...mapActions('categories', [
            'getCategories'
        ]),
        ...mapActions('units', [
            'getAllUnits'
        ]),
        ...mapActions('brands', [
            'getBrands'
        ]),
        ...mapActions('patterns', [
            'getPatterns',
            'setPatterns'
        ]),
        ...mapActions('colors', [
            'getColors'
        ]),
        ...mapActions('variants', [
            'getVariants',
            'getVariantOptions',
            'setVariantsHeader',
            'setRowSelected',
            'replaceVariantRow',
            'setVariantsRows'
        ]),
        ...mapActions('products', [
            'store'
        ]),
        async clearData () {
            this.form.name = null;
            this.form.category_id = null;
            this.form.brand_id = null;
            this.form.pattern_id = null;
            this.form.color_id = null;
            this.form.unit_id = null;
            this.form.sku = null;
            this.form.barcode = null;
            this.form.with_variants = false;
            this.form.variants = null;
            this.form.variants_header = null;
            this.setVariantsHeader([]);
            this.setVariantsRows([]);
            await this.clearErrors();
        },
        customText(item){
            let text = item.name
            
            return text
        },
        handleChangeWithVariants (value) {
            this.setVariantsHeader([]);
            this.setVariantsRows([]);
        },
        hanndleViewAddVariant () {
            this.$refs.addVariant.show();
        },
        handleFocusInput (variantRow) {
            this.setRowSelected(variantRow);
        },
        handleInputBarcode (barcode) {
            let row = Object.assign({}, this.row_selected);
            row.barcode = barcode;
            this.updateRow(row);
        },
        handleInputUnitPrice (price_value) {
            let row = Object.assign({}, this.row_selected);
            row.unit_price = parseFloat(price_value);
            this.updateRow(row);
        },
        handleInputWholesalePrice (wholesale_price) {
            let row = Object.assign({}, this.row_selected);
            row.wholesale_price = parseFloat(wholesale_price);
            this.updateRow(row);
        },
        handleInputPreferentialPrice (preferential_price) {
            let row = Object.assign({}, this.row_selected);
            row.preferential_price = parseFloat(preferential_price);
            this.updateRow(row);
        },
        updateRow (row) {
            let index = Tools.findIndexFromItem(this.variants_rows, row.id);
            if (index > -1) {
                this.replaceVariantRow({
                    index: index,
                    row: row
                })
            }
        },
        handleChangeBrand (value) {
            if (value !== undefined && value !== null) {
                this.getPatterns({
                    brand_id: value
                });
            } else {
                this.setPatterns([]);
            }
        },
        handleCancelSave () {
            router.push('/products');
        },
        async handleSaveProduct () {
            if (!this.existErrors()) {
                if (this.validateVariants() == 'error') {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'REGISTRO DE PRODUCTO',
                        text: 'Debe ingresar las vaiantes del producto'
                    });
                } else {
                    this.form.variants = Object.assign([], this.variants_rows);
                    this.form.variants_header = Object.assign([], this.variants_header);
                    await this.store(this.form);
                    if (this.product_response == 'error') {                        
                        this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'REGISTRO DE PRODUCTO',
                            text: 'Ocurrió un error al registrar producto.'
                        });
                    } else {
                        this.clearData();
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            title: 'REGISTRO DE PRODUCTO',
                            text: 'Producto registrado de forma correcta.'
                        });                    
                    }
                }                
            }            
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.form).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.form[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.form).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },
        validateVariants () {
            let status = 'success';
            if (this.form.with_variants == true) {
                if (this.variants_rows.length < 1) {
                    status = 'error';
                }
            }
            return status;
        },
        loadData () {
            //this.getVariants();
            //this.getVariantOptions();
            this.getAllUnits();
            this.getBrands();
            this.getColors();
        }
    },
    created () {
        this.setVariantsRows([]);
        this.loadData();
    }
}
</script>

<style scoped>

</style>